import { render } from "./ServiceList.vue?vue&type=template&id=2c9931a3&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"

import "./ServiceList.vue?vue&type=style&index=0&id=2c9931a3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9931a3"]])

export default __exports__